import React, { useEffect } from "react";
import GModal from "components/ui/modal/Modal";
import { useTranslation } from "react-i18next";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import GButton from "components/ui/button/Button";
import { useDispatch, useSelector } from "react-redux";
import { getCategories } from "features/products/categories/services/categoriesService";
import {
  deactiveComboinsomebranches,
  getInactiveBranhesById,
} from "../../services/combosService";
import { getBranches } from "features/management/branches/services/branchesService";
import { useParams } from "react-router-dom";

const InactiveBrancheModal = ({ onClose }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBranches());
  }, [dispatch]);

  const branches = useSelector((state) => state.branches);

  const { comboId } = useParams();

  const { t } = useTranslation();

  const { handleSubmit, setValue } = useForm();

  const id = useParams();

  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });

  const toast2 = useToast({
    position: "top",
    duration: 3000,
    status: "error",
  });

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.combos.select_branches")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              values.UserId = localStorage.getItem("userId");
              values.BranchId = values.BranchId?.BranchId;
              values.ComboId = id.comboId;
              if (values.BranchId === undefined) {
                toast2({
                  description: t("pages.DailyRestrictions.searchvalidation"),
                });
              } else {
                dispatch(deactiveComboinsomebranches(values))
                  .unwrap()
                  .then((_) => {
                    toast({ description: t("pages.combos.combo_created") });
                    dispatch(getInactiveBranhesById(comboId));
                    onClose();
                  });
              }
            })}
          >
            <Stack spacing={6}>
              <MultiSelect
                title={t("pages.combos.category")}
                data={
                  branches.data &&
                  branches.data.map((el) => ({
                    ...el,
                    label: el.BranchName,
                    value: el.BranchId,
                  }))
                }
                isMulti={false}
                isRequired
                onChange={(e) => setValue("BranchId", e)}
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  isLoading={branches.isLoading}
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  isLoading={branches.isLoading}
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default InactiveBrancheModal;
